import Link from 'next/link';

import styles from './RedirectImage.module.scss';

export default function RedirectImage({ tile, altText }) {
  const tileTitle = tile?.title;
  return (
    <div className={styles.bannerContainer}>
      <p className={styles.bannerTitle}>{tileTitle || altText}</p>
      <Link href={tile?.fields?.redirectionLink || '/#'}>
        <a aria-label={tileTitle || altText}>
          <img
            className={styles.img}
            src={tile?.fields?.image?.path}
            width={320}
            height={220}
            alt={tileTitle || altText}
          />
        </a>
      </Link>
    </div>
  );
}
